import api from './api';

export async function fetchSidebarData() {
  const response = await api.get('/get-sidebar-data');
  return response?.data?.dataset?.data || {};
}
